import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export const getAllCategories = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/category`);
    console.log("Categories for select", response);

    return response.data;
  } catch (error) {
    console.error("Error creating categories:", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Something went wrong",
    };
  }
};

export const getPopularCategories = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/category/popular`);
    console.log("Popular categories", response);

    return response.data;
  } catch (error) {
    console.error("Error fetching popular categories:", error);
    return {
      success: false,
      message: error?.response?.data?.message || "Something went wrong",
    };
  }
};